import '../../resources/css/common/ModalTip.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { closeModalTip } from '../../actions/index';

class ModalTip extends Component {

  closeModal = () => {
    const { closeModalTip, callback } = this.props;
    closeModalTip();

    setTimeout(() => {
      if (callback) {
        callback();
      }
    }, 50);
  }

  render() {
    const { isTipShow, tipText, refTitle } = this.props;
    let title = refTitle ? refTitle : "Tip";

    let renderContent;
    if (isTipShow) {
      renderContent = (
        <Modal
            show={isTipShow}
            dialogClassName='modal-tip'
            centered
        >
          <Modal.Body>
            <div className='area-modal-tip-header'>
                <label>{ title }</label>
            </div>
            <div className='area-modal-tip-content'>
              <br />
              <span className='icon-succeed'></span>
              <br />
              <label>{tipText}</label>
              <hr />
              <div className='area-btn'>
                <Button type="button" variant="primary" className='btn-ok' onClick={this.closeModal}>OK</Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )
    } else {
      renderContent = (<div className='modal-detail-empty'></div>);
    }

    return (
      <div className='area-modal-alert'>
          {renderContent}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isTipShow: state.commonReducers.isTipShow,
    tipText: state.commonReducers.tipText,
    refTitle: state.commonReducers.refTitle,
    callback: state.commonReducers.callback
  }
}

export default connect(
  mapStateToProps,
  { closeModalTip }
)(ModalTip)